import{d as r}from"./chunk-73U45M5A.js";import{q as i}from"./chunk-MOWIYUQE.js";import{b as o}from"./chunk-AOHGKBTF.js";import{m as t}from"./chunk-HBP5N4FR.js";t();i();function p(e){return r(n=>o(n,e))}export{p as a};
//# sourceMappingURL=chunk-VHG4Y2RY.js.map
